import React, { useState, useEffect } from 'react';
import api from '../utils/axiosConfig';
import './Docks.css';
import './TableStyles.css';

const Docks = () => {
  const [docks, setDocks] = useState([]);
  const [formData, setFormData] = useState({
    number: '',
    capacity: ''
  });
  const [editingId, setEditingId] = useState(null);
  const [message, setMessage] = useState('');

  // Fetch docks
  useEffect(() => {
    const fetchDocks = async () => {
      try {
        const response = await api.get('/docks');
        setDocks(response.data);
      } catch (error) {
        console.error('Error fetching docks:', error);
      }
    };
    
    fetchDocks();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      if (editingId) {
        // Update existing dock
        const response = await api.put(`/docks/${editingId}`, formData);
        setDocks(docks.map(dock => 
          dock._id === editingId ? response.data : dock
        ));
        setMessage('Doca atualizada com sucesso!');
      } else {
        // Create new dock
        const response = await api.post('/docks', formData);
        setDocks([...docks, response.data]);
        setMessage('Doca criada com sucesso!');
      }
      
      // Reset form
      setFormData({
        number: '',
        capacity: ''
      });
      setEditingId(null);
    } catch (error) {
      setMessage('Erro: ' + error.response?.data?.message || error.message);
    }
  };

  const handleEdit = (dock) => {
    setFormData({
      number: dock.number,
      capacity: dock.capacity
    });
    setEditingId(dock._id);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Tem certeza que deseja excluir esta doca?')) {
      try {
        await api.delete(`/docks/${id}`);
        setDocks(docks.filter(dock => dock._id !== id));
        setMessage('Doca excluída com sucesso!');
      } catch (error) {
        setMessage('Erro ao excluir doca: ' + error.response?.data?.message || error.message);
      }
    }
  };

  const handleCancelEdit = () => {
    setFormData({
      number: '',
      capacity: ''
    });
    setEditingId(null);
  };

  return (
    <div className="docks-container">
      <h2>Cadastro de Docas</h2>
      
      {message && (
        <div className={`message ${message.includes('sucesso') ? 'success' : 'error'}`}>
          {message}
        </div>
      )}
      
      <form onSubmit={handleSubmit} className="dock-form">
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="number">Número da Doca *</label>
            <input
              type="number"
              id="number"
              name="number"
              value={formData.number}
              onChange={handleInputChange}
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="capacity">Capacidade *</label>
            <input
              type="number"
              id="capacity"
              name="capacity"
              value={formData.capacity}
              onChange={handleInputChange}
              required
            />
          </div>
        </div>
        
        <div className="form-actions">
          <button type="submit" className="btn-save">
            {editingId ? 'Atualizar Doca' : 'Adicionar Doca'}
          </button>
          {editingId && (
            <button type="button" className="btn-cancel" onClick={handleCancelEdit}>
              Cancelar
            </button>
          )}
        </div>
      </form>
      
      <div className="docks-list">
        <h3>Docas Cadastradas</h3>
        {docks.length > 0 ? (
          <div className="global-table-container">
            <table className="global-table">
              <thead>
                <tr>
                  <th>Número</th>
                  <th>Capacidade</th>
                  <th>Status</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {docks.map(dock => (
                  <tr key={dock._id}>
                    <td>{dock.number}</td>
                    <td>{dock.capacity} caminhões</td>
                    <td>
                      <span className={`status ${dock.status.toLowerCase()}`}>
                        {dock.status === 'ATIVA' ? 'Ativa' : 
                         dock.status === 'MANUTENCAO' ? 'Manutenção' : 'Inativa'}
                      </span>
                    </td>
                    <td>
                      <button 
                        className="btn-edit"
                        onClick={() => handleEdit(dock)}
                      >
                        Editar
                      </button>
                      <button 
                        className="btn-delete"
                        onClick={() => handleDelete(dock._id)}
                      >
                        Excluir
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p>Nenhuma doca cadastrada.</p>
        )}
      </div>
    </div>
  );
};

export default Docks;